module.exports = __webpack_public_path__ + "static/media/street-triple-wp.815e59d8.jpg";